import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './state/AuthContext'
import { AppShell } from './shell/AppShell'
import { LoginPage } from './pages/LoginPage'
import { MateriaListPage } from './pages/criador-de-midias/MateriaListPage'
import { MateriaEditorPage } from './pages/criador-de-midias/MateriaEditorPage'
import { LinkBioAdminPage } from './pages/link-bio/LinkBioAdminPage'
import { LinkBioPage } from './pages/link-bio/LinkBioPage'
import { TasksPage } from './pages/tasks/TasksPage'
import { UserManagerPage } from './pages/users/UserManagerPage'

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/entrar" element={<LoginPage />} />
          <Route path="/bio" element={<LinkBioPage />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/criador-de-midias" replace />} />
            <Route path="/criador-de-midias" element={<MateriaListPage />} />
            <Route path="/criador-de-midias/:materiaId" element={<MateriaEditorPage />} />
            <Route path="/link-bio" element={<LinkBioAdminPage />} />
            <Route path="/tarefas" element={<TasksPage />} />
            <Route path="/usuarios" element={<UserManagerPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
